import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Global error listeners (log only)
window.addEventListener("error", (e) => console.error("[CuraCheck] Errore globale:", e.error || e.message));
window.addEventListener("unhandledrejection", (e) => console.error("[CuraCheck] Promise non gestita:", e.reason));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
